import {
  DatePicker,
  DefaultButton,
  DetailsList,
  DetailsListLayoutMode,
  IComboBoxOption,
  IDatePickerStyles,
  ITextFieldStyles,
  PrimaryButton,
  SelectionMode,
  Stack,
  Text,
  TextField,
} from "@fluentui/react";
import TimeTaxSupportSystemClient from "../../system";
import { useEffect, useState } from "react";
import { IDataHolidaysGroup } from "../../system/non_working_days/NonWorkingDays";
import { getLocalizedStrings } from "../../lib/LocalizedStringsForDatePicker";
import { t } from "i18next";
import MessageCourier from "../../lib/MessageCourier";

interface IListHolidays {
  system: TimeTaxSupportSystemClient;
  company: IComboBoxOption | undefined;
  date: any;
  onRegisterChange?: (dataRegister: any) => void;
  courier: MessageCourier;
  // user: User;
  // changeBlockUI: (state: boolean) => void;
  // config: SystemConfiguration;
  // periodsBlocked: PeriodDatesBlockedSystem;
}

const initialHoliDays: IDataHolidaysGroup = {
  dnl_fecha_descripcion: "",
  dnl_paisid: "",
  dnl_activo: 1,
  dnl_fecha_no_laboral:"",
  item:1
};

const textFieldStyles: Partial<ITextFieldStyles> = {
  field: {
    "::placeholder": {
      color: "#aaa",
    },
  },
  subComponentStyles: {
    label: {
      root: {
        padding: "1.5px 0px",
      },
    },
  },
};

const CalendarStyles: Partial<IDatePickerStyles> = {
  textField: {
    fieldGroup: {
      border: "1px solid #aaa",
    },
    width: 150,
  },
};

export const ListHolidays = (props: IListHolidays) => {
  const [listHolidays, setListHolidays] = useState<IDataHolidaysGroup[]>([]);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [bodyHoliday, setBodyHoliday] = useState<IDataHolidaysGroup>(initialHoliDays);
  const isVisibleComponent = isVisible ? "visible" : "hidden";
  const [isRegister, setIsRegister] = useState<any>(undefined);

  const isDisabled =
    bodyHoliday.dnl_fecha_descripcion?.length &&
    bodyHoliday.dnl_fecha_no_laboral;

  const holidayColumns = [
    {
      key: "item",
      name: t("Item"),
      fieldName: "item",
      minWidth: 80,
    },
    {
      key: "dnl_fecha_descripcion",
      name: t("Nombre del feriado"),
      fieldName: "dnl_fecha_descripcion",
      minWidth: 200,
    },
    {
      key: "dnl_fecha_no_laboral",
      name: t("Fecha"),
      fieldName: "dnl_fecha_no_laboral",
      minWidth: 100,
    },
    {
      key: "accion",
      name: t("Acciones"),
      fieldName: "accion",
      minWidth: 100,
      onRender: (item: IDataHolidaysGroup) => (
        <DefaultButton
          iconProps={{ iconName: "Delete", styles: { root: { fontSize: 22, color: 'red' } } }}
          style={{ backgroundColor: "transparent", border: "none" }}
          onClick={() => handleDeleteWorkingDays(item)}
        />
      ),
    },
  ];

  useEffect(() => {
    if (props.company?.key && props.date) {
      getCalendarData(props.date, props.company.key.toString());
    }
  }, [props.company, props.date, isRegister]);

  const getCalendarData = async (date: Date, emppId: string) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const dateToSend = `${year}-${month}`;
    const data = await props.system
      .getNonWorkingDaysSystem()
      .getListHolidays(dateToSend, emppId);
    setListHolidays(data);
  };

  const handleRegisterWorkingDays = async (data:any) => {
    if (!data.dnl_fecha_no_laboral) {
      props.courier.messageError(t('La fecha es obligatoria'));
      return;
    }

    if (!props.company?.key) {
      props.courier.messageError(t('No existe una compañía seleccionada'));
      return;
    }

    const result = await props.system
      .getNonWorkingDaysSystem()
      .registerWorkingDays("Registro de feriados", {
        ...data,
        dnl_empp_id: props.company?.key,
        dnl_paisid: props.company?.data.empp_paisid,
      });

    setIsRegister(result);

    if (props.onRegisterChange) {
      props.onRegisterChange(result);
    }

    handleClearDataHoliDay();
  };

  const handleDeleteWorkingDays = (holiDay:any) => {
    holiDay.dnl_activo = false;
    handleRegisterWorkingDays(holiDay);
  }

  const handleClearDataHoliDay = () => {
    setBodyHoliday({
      ...initialHoliDays,
      dnl_paisid: bodyHoliday.dnl_paisid,
    });
    setIsVisible(!isVisible);
  };

  const handleOnChangeDescription = (newValue: string) => {
    setBodyHoliday((prevState) => ({
      ...prevState,
      dnl_fecha_descripcion: newValue,
    }));
  };

  const handleOnClickDate = (date) => {
    setBodyHoliday((prevState) => ({
      ...prevState,
      dnl_fecha_no_laboral: date ? date.toISOString().split("T")[0] : "",
    }));
  };

  return (
    <>
      <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
        <Text variant="mediumPlus" className="mb-2">
          {t('Control de feriados')}
        </Text>
        <Stack
          horizontal
          verticalAlign="center"
          tokens={{ childrenGap: 20 }}
          className={isVisibleComponent}
        >
          <DefaultButton
            text={t("Cancelar")}
            style={{ width: "15px", fontSize: "12px" }}
            className="mt-5"
            onClick={handleClearDataHoliDay}
          />
          <PrimaryButton
            text={t("Guardar")}
            iconProps={{ iconName: "Save" }}
            style={{ width: "15px", fontSize: "12px" }}
            className="mt-5"
            disabled={!isDisabled}
            onClick={() => handleRegisterWorkingDays(bodyHoliday)}
          />
        </Stack>
        <PrimaryButton
          text={t("Agregar")}
          iconProps={{ iconName: "Add" }}
          style={{ width: "15px", fontSize: "12px" }}
          className={`${!isVisible ? "visible" : "hidden"} mt-5`}
          onClick={() => setIsVisible(!isVisible)}
        />
      </Stack>
      <Stack
        horizontal
        verticalAlign="center"
        horizontalAlign="start"
        gap={20}
        className={isVisibleComponent}
      >
        <TextField
          value={bodyHoliday.dnl_fecha_descripcion}
          label={t("Nombre")}
          autoComplete="off"
          onChange={(e, newValue) => handleOnChangeDescription(newValue || "")}
          name="dnl_fecha_descripcion"
          styles={textFieldStyles}
          className="filter-textfield-list"
          placeholder={t("Escribir nombre")}
        />
        <DatePicker
          value={
            bodyHoliday.dnl_fecha_no_laboral
              ? new Date(
                  new Date(bodyHoliday.dnl_fecha_no_laboral).setDate(
                    new Date(bodyHoliday.dnl_fecha_no_laboral).getDate() + 1
                  )
                )
              : undefined
          }
          strings={getLocalizedStrings()}
          label={t("Fecha de feriado")}
          onSelectDate={handleOnClickDate}
          styles={CalendarStyles}
          className="filter-textfield-list"
          formatDate={(date) =>
            date
              ? `${date.getDate().toString().padStart(2, "0")}/${(
                  date.getMonth() + 1
                )
                  .toString()
                  .padStart(2, "0")}/${date.getFullYear()}`
              : ""
          }
          placeholder="DD/MM/AAAA"
        />
      </Stack>
      <DetailsList
        className="barraInferior"
        items={listHolidays}
        columns={holidayColumns}
        selectionMode={SelectionMode.none}
        layoutMode={DetailsListLayoutMode.fixedColumns}
        isHeaderVisible={true}
        setKey="none"
        onRenderRow={(props, defaultRender) => {
          if (!props) return null;
          return defaultRender
            ? defaultRender({
                ...props,
                styles: {
                  root: {
                    backgroundColor:
                      props.itemIndex % 2 === 0 ? "#F5F5F5" : "#FFFFFF",
                  },
                },
              })
            : null;
        }}
      />
    </>
  );
};
